import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpContextToken } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

// HTTP Context token to skip loading spinner
export const SKIP_LOADING_SPINNER = new HttpContextToken<boolean>(() => false);

export const LoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Check if request should skip loading spinner
  const skipSpinner = req.context.get(SKIP_LOADING_SPINNER);

  if (!skipSpinner) {
    // Show loading spinner
    loadingService.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (!skipSpinner) {
        // Hide loading spinner when request completes (success or error)
        loadingService.hide();
      }
    })
  );
};